var _defs, _rect, _pattern, _rect2, _rect3, _text, _text2, _g, _g2, _g3, _g4, _g5, _rect4, _text3, _text4, _rect5, _rect6, _text5, _text6, _line, _text7, _text8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHilo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 600",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c0820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#100c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#07051a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-main",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e1840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#130f2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-side",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#16122e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f0c22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-g",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c776ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e0a8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btn-hi",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a3d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0e2a0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btn-lo",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3d1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a0e0e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodColor: "rgba(0,0,0,0.6)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#bg)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0 L0 0 0 30",
    fill: "none",
    stroke: "rgba(199,118,255,0.04)",
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#g)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 3,
    fill: "url(#title-g)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 58,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "url(#title-g)",
    letterSpacing: 6
  }, "HI-LO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 80,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3
  }, "PREDICT THE NEXT CARD")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,150) rotate(-12,65,100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 180,
    rx: 14,
    fill: "url(#card-side)",
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1,
    filter: "url(#card-shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 30,
    fontFamily: "'Georgia',serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#ef4444"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 112,
    textAnchor: "middle",
    fontFamily: "serif",
    fontSize: 56,
    fill: "#ef4444"
  }, "\u2665"), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 168,
    textAnchor: "end",
    fontFamily: "'Georgia',serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#ef4444",
    transform: "rotate(180,116,162)"
  }, "7"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(238,150) rotate(12,65,100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 180,
    rx: 14,
    fill: "url(#card-side)",
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1,
    filter: "url(#card-shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 30,
    fontFamily: "'Georgia',serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#e8e8f0"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 112,
    textAnchor: "middle",
    fontFamily: "serif",
    fontSize: 56,
    fill: "#e8e8f0"
  }, "\u2663"), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 168,
    textAnchor: "end",
    fontFamily: "'Georgia',serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#e8e8f0",
    transform: "rotate(180,116,162)"
  }, "A"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(145,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 220,
    rx: 16,
    fill: "url(#card-main)",
    stroke: "rgba(199,118,255,0.45)",
    strokeWidth: 1.5,
    filter: "url(#card-shadow)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 138,
    height: 208,
    rx: 12,
    fill: "none",
    stroke: "rgba(199,118,255,0.12)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 36,
    fontFamily: "'Georgia',serif",
    fontSize: 26,
    fontWeight: 800,
    fill: "#c776ff"
  }, "K"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 140,
    textAnchor: "middle",
    fontFamily: "serif",
    fontSize: 70,
    fill: "#c776ff"
  }, "\u2660"), /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 205,
    textAnchor: "end",
    fontFamily: "'Georgia',serif",
    fontSize: 26,
    fontWeight: 800,
    fill: "#c776ff",
    transform: "rotate(180,134,198)"
  }, "K"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,370)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 8,
    fill: "rgba(239,68,68,0.1)",
    stroke: "rgba(239,68,68,0.3)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#ef4444"
  }, "1.14\xD7"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(292,370)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 8,
    fill: "rgba(114,242,56,0.1)",
    stroke: "rgba(114,242,56,0.3)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#72F238"
  }, "3.60\xD7"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 420,
    width: 168,
    height: 56,
    rx: 12,
    fill: "url(#btn-lo)",
    stroke: "rgba(239,68,68,0.4)",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 446,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "rgba(255,255,255,0.5)",
    letterSpacing: 1
  }, "NEXT CARD IS")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 465,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 16,
    fontWeight: 800,
    fill: "#ef4444",
    letterSpacing: 1
  }, "\u25BC LOWER")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 420,
    width: 168,
    height: 56,
    rx: 12,
    fill: "url(#btn-hi)",
    stroke: "rgba(114,242,56,0.4)",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 420,
    width: 168,
    height: 56,
    rx: 12,
    fill: "none",
    stroke: "rgba(114,242,56,0.6)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.8;0",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 446,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "rgba(255,255,255,0.5)",
    letterSpacing: 1
  }, "NEXT CARD IS")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 465,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 16,
    fontWeight: 800,
    fill: "#72F238",
    letterSpacing: 1
  }, "\u25B2 HIGHER")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 498,
    x2: 408,
    y2: 498,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 530,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.3)",
    letterSpacing: 2
  }, "WIN STREAK")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 558,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 36,
    fontWeight: 900,
    fill: "url(#title-g)"
  }, "\xD7 5")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 582,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fill: "rgba(255,255,255,0.25)",
    letterSpacing: 2
  }, "NEXTGEN ORIGINALS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHilo);
export default __webpack_public_path__ + "static/media/hilo.bc250f865a5d5fdd3a0d9dcb68dc4284.svg";
export { ForwardRef as ReactComponent };